var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublicOpportunities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-public-opportunities,.cls-2{\r\n                fill:#c5c9f6;\r\n            }\r\n            .cls-2{\r\n                fill-rule:evenodd;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    className: "cls-public-opportunities",
    d: "M18.77,12.5a5.07,5.07,0,0,1,3.09,1V4.66H15.53V1.89H9.33V4.66H3v13.8H13.72a5.12,5.12,0,0,1,4.21-5.89,4.76,4.76,0,0,1,.84-.07ZM14,6.08H10.85V3.4H14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    className: "cls-public-opportunities",
    d: "M23,21.18H22.5L22.33,21a3.94,3.94,0,0,0-3-6.5h0a3.93,3.93,0,0,0-3.93,3.94h0a3.93,3.93,0,0,0,3.93,3.93h0a3.88,3.88,0,0,0,2.56-.95l.17.17     v.48l3,3,.9-.9-3-3Zm-3.64,0a2.72,2.72,0,0,1-2.72-2.72h0a2.73,2.73,0,1,1,2.72,2.72Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicOpportunities);
export default __webpack_public_path__ + "static/media/public-opportunities.0c7d915972fa9042619b50bce0e5c296.svg";
export { ForwardRef as ReactComponent };